import { createStyles, Divider, makeStyles } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import React, { ReactText, useContext, useEffect } from "react";
import { OutputType, RemoteOutput } from "../../treeBlockOutputsDataSource";
import {
  LocalOutput,
  treeBlockConfigurations,
  treeBlockOutputsContext
} from "../../schema";
import { TreeBlockType } from "../../TreeBlockType";
import { OutputForm } from "./OutputForm";
import { OutputList } from "./OutputList";
import { OutputTypeSelector } from "./OutputTypeSelector";

interface TreeBlockOutputViewProps {
  selectedTreeBlockId: ReactText;
  treeBlockType: TreeBlockType;
  handleAddOutput: (blockId: ReactText, output: LocalOutput) => void;
  handleRemoveOutput: (blockId: ReactText, output: LocalOutput) => boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      overflowY: "auto"
    }
  })
);

export const OutputView = observer((props: TreeBlockOutputViewProps) => {
  const outputsContext = useContext(treeBlockOutputsContext);
  const { selectedTreeBlockId, treeBlockType } = props;
  const classes = useStyles();

  const addOutputOption = (
    treeBlockId: ReactText,
    blockType: TreeBlockType,
    newOutput: RemoteOutput
  ): void => {
    outputsContext.addDynamicOutputOption(treeBlockId, blockType, {
      value: newOutput.output,
      label: newOutput.output,
      type: outputsContext.formOutputType,
      isDynamicOption: true
    });
  };

  useEffect(() => {
    if (treeBlockConfigurations[treeBlockType].outputTypes) {
      outputsContext.setFormOutputType(
        // @ts-ignore
        treeBlockConfigurations[treeBlockType].outputTypes[0]
      );
    }
    return () => outputsContext.setFormOutputType(null);
  }, [treeBlockType, selectedTreeBlockId]);

  const handleSelectType = (outputType: OutputType): void => {
    outputsContext.setFormOutputType(outputType);
  };

  return (
    <div className={classes.container}>
      <OutputList
        outputOptions={outputsContext.outputOptions[selectedTreeBlockId]}
        treeBlockId={selectedTreeBlockId}
        treeBlockType={treeBlockType}
        handleAddOutput={props.handleAddOutput}
        handleRemoveOutput={props.handleRemoveOutput}
      />
      {treeBlockConfigurations[treeBlockType].outputFormSchema && (
        <>
          <Divider />
          {treeBlockConfigurations[treeBlockType].outputTypes &&
            // @ts-ignore
            treeBlockConfigurations[treeBlockType].outputTypes.length > 1 && (
              <OutputTypeSelector
                outputTypes={
                  treeBlockConfigurations[treeBlockType].outputTypes || []
                }
                handleSelectType={handleSelectType}
                outputType={outputsContext.formOutputType}
              />
            )}
          {outputsContext.getOutputSchema(treeBlockType) &&
            outputsContext.formOutputType && (
              <OutputForm
                treeBlockId={selectedTreeBlockId}
                blockType={treeBlockType}
                schema={outputsContext.getOutputSchema(treeBlockType)}
                handleAddOutputToList={addOutputOption}
              />
            )}
        </>
      )}
    </div>
  );
});
